module.exports = __webpack_public_path__ + "img/Flag_of_Norfolk_Island.6860552f.svg";